<template>
  <div
    class="absolute-fill gc-border"
    v-bind:class="{ clickable }"
    v-on="clickable ? { click: () => $emit('click') } : {}"
  />
</template>

<style scoped>
.clickable {
  cursor: pointer;
  pointer-events: auto;
  transition: background-color .13s;
}
.clickable:hover {
  background-color: rgba(0, 0, 0, .2);
}
</style>

<script>
export default {
  name: 'giftcard-blob-controls',
  props: [ 'mode', 'isPageActive' ],
  computed: {
    clickable() {
      return this.isPageActive && [ 'preview', 'view' ].includes(this.mode);
    }
  }
}
</script>
